import { GisVendorAdapter } from './gis-vendor-adapter';
import { GisAddressInfo, GisEntityInfo, GisEntityName, GisError, GisInboundEvent } from './gis.models';

/** GiSoftGis iframe mesaj zarfı (`{ messageName, messageArgs }`). */
interface GiSoftMessageContext {
  messageName: string;
  messageArgs: Record<string, unknown>;
}

function isGiSoftMessage(data: unknown): data is GiSoftMessageContext {
  return !!data && typeof data === 'object' && typeof (data as GiSoftMessageContext).messageName === 'string';
}

/**
 * GiSoftGis postMessage protokolü (GiSoft'un HaritaMinimal.html örneği):
 *  - giden: showEntityOnMapById { entityName, entityId }
 *  - gelen: initializeComplete, getEntityInfoComplete, getAddressInfoComplete, errorOccured
 */
export class GiSoftGisAdapter implements GisVendorAdapter {
  readonly vendor = 'GiSoft';

  buildShowEntityMessage(entityName: GisEntityName, entityId: number): GiSoftMessageContext {
    return { messageName: 'showEntityOnMapById', messageArgs: { entityName, entityId } };
  }

  parseInbound(data: unknown): GisInboundEvent | null {
    if (!isGiSoftMessage(data) || !data.messageName) return null;
    const args = (data.messageArgs ?? {}) as Record<string, unknown>;
    switch (data.messageName) {
      case 'initializeComplete':
        return { type: 'ready' };
      case 'getEntityInfoComplete':
        return { type: 'entityInfo', info: args as GisEntityInfo };
      case 'getAddressInfoComplete':
        return { type: 'addressInfo', info: args as GisAddressInfo };
      case 'errorOccured':
        return { type: 'error', error: args as GisError };
      default:
        return { type: 'unknown', name: data.messageName };
    }
  }
}

/**
 * app.settings `gisVendor` değerine göre adapter döner.
 * Tanımsız/boş/bilinmeyen değer → null: harita lisanssız kabul edilir ve hiç yüklenmez.
 */
export function resolveGisAdapter(vendor: string | null | undefined): GisVendorAdapter | null {
  switch ((vendor ?? '').trim().toLocaleLowerCase('en-US')) {
    case 'gisoft':
      return new GiSoftGisAdapter();
    default:
      return null;
  }
}
